import { createAction, createActions } from 'redux-actions';

const namespace = 'campaignOfferInfo';

export const OFFER_INFO_LOAD_REQUESTED = `${namespace}/LOAD_OFFER_REQUESTED`;
export const OFFER_INFO_LOAD_AFTER_LOGIN_REQUESTED = `${namespace}/LOAD_OFFER_AFTER_LOGIN_REQUESTED`;
export const OFFER_INFO_FETCH_SUCCEEDED = `${namespace}/FETCH_OFFER_INFO_SUCCESS`;
export const OFFER_INFO_FETCH_FAILED = `${namespace}/FETCH_OFFER_INFO_FAILURE`;

export const OFFER_VOUCHER_INFO_LOAD_REQUESTED = `${namespace}/OFFER_VOUCHER_REQUESTED`;
export const OFFER_VOUCHER_INFO_FETCH_SUCCEEDED = `${namespace}/FETCH_OFFER_VOUCHER_INFO_SUCCESS`;
export const OFFER_VOUCHER_INFO_FETCH_FAILED = `${namespace}/FETCH_OFFER_VOUCHER_INFO_FAILURE`;

export const loadOfferInfoRequest = createAction(OFFER_INFO_LOAD_REQUESTED);
export const loadOfferInfoAfterLoginRequest = createAction(OFFER_INFO_LOAD_AFTER_LOGIN_REQUESTED);
export const loadOfferVoucherInfoRequest = createAction(OFFER_VOUCHER_INFO_LOAD_REQUESTED);

export const {
  campaignOfferInfo: {
    fetchOfferInfoSuccess,
    fetchOfferInfoFailure,
    loadOfferRequest,
    loadOfferAfterLogin,
    fetchOfferVoucherInfoSuccess,
    fetchOfferVoucherInfoFailure,
    loadOfferVoucherRequest,
  },
} = createActions({
  [OFFER_INFO_FETCH_SUCCEEDED]: payload => payload,
  [OFFER_INFO_FETCH_FAILED]: payload => payload,
  [OFFER_INFO_LOAD_REQUESTED]: payload => payload,
  [OFFER_INFO_LOAD_AFTER_LOGIN_REQUESTED]: payload => payload,
  [OFFER_VOUCHER_INFO_FETCH_SUCCEEDED]: payload => payload,
  [OFFER_VOUCHER_INFO_FETCH_FAILED]: payload => payload,
  [OFFER_VOUCHER_INFO_LOAD_REQUESTED]: payload => payload,
});

